import React from 'react';
import { FileText, Search, Coins } from 'lucide-react';
import { Button } from './ui/Button';
import { useTranslations } from '../hooks/useTranslations';
export function HowItWorks() {
  const {
    t
  } = useTranslations();
  const steps = [{
    id: 1,
    icon: <FileText className="w-8 h-8 text-white" data-id="element-262" />,
    title: t('howItWorks.step1.title'),
    description: t('howItWorks.step1.desc')
  }, {
    id: 2,
    icon: <Search className="w-8 h-8 text-white" data-id="element-263" />,
    title: t('howItWorks.step2.title'),
    description: t('howItWorks.step2.desc')
  }, {
    id: 3,
    icon: <Coins className="w-8 h-8 text-white" data-id="element-264" />,
    title: t('howItWorks.step3.title'),
    description: t('howItWorks.step3.desc')
  }];
  return <section id="how-it-works" className="py-20 bg-white" data-id="element-265">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-266">
        <div className="text-center mb-16" data-id="element-267">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-268">
            {t('howItWorks.title')}{' '}
            <span className="text-[#00E676]" data-id="element-269">
              {t('howItWorks.titleHighlight')}
            </span>
          </h2>
          <p className="text-lg text-gray-600" data-id="element-270">{t('howItWorks.subtitle')}</p>
        </div>

        <div className="relative grid grid-cols-1 md:grid-cols-3 gap-12" data-id="element-271">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-gray-200 -z-10" data-id="element-272"></div>

          {steps.map(step => <div key={step.id} className="flex flex-col items-center text-center relative" data-id="element-273">
              <div className="w-24 h-24 rounded-full bg-[#00E676] flex items-center justify-center shadow-lg mb-6 relative z-10 border-4 border-white" data-id="element-274">
                {step.icon}
                <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full bg-gray-900 text-white flex items-center justify-center font-bold border-2 border-white" data-id="element-275">
                  {step.id}
                </div>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-276">
                {step.title}
              </h3>
              <p className="text-gray-600 max-w-xs" data-id="element-277">{step.description}</p>
            </div>)}
        </div>

        <div className="mt-16 text-center" data-id="element-278">
          <Button size="lg" onClick={() => document.getElementById('contact')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-279">
            {t('howItWorks.cta')}
          </Button>
        </div>
      </div>
    </section>;
}